import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function writeAny(_this__u8e3s4, value) {
  if (value == null)
    _this__u8e3s4.t3z();
  else {
    if (isInterface(value, KtMap())) {
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.o40();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = value.l3().p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        // Inline function 'kotlin.collections.component1' call
        var key = element.m3();
        // Inline function 'kotlin.collections.component2' call
        var value_0 = element.n3();
        _this__u8e3s4.q47(toString_0(key));
        writeAny(_this__u8e3s4, value_0);
      }
      _this__u8e3s4.p40();
    } else {
      if (isInterface(value, KtList())) {
        // Inline function 'com.apollographql.apollo.api.json.writeArray' call
        _this__u8e3s4.t40();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = value.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          writeAny(_this__u8e3s4, element_0);
        }
        _this__u8e3s4.u40();
      } else {
        if (typeof value === 'boolean')
          _this__u8e3s4.k41(value);
        else {
          if (typeof value === 'number')
            _this__u8e3s4.c41(value);
          else {
            if (typeof value === 'bigint')
              _this__u8e3s4.i41(value);
            else {
              if (typeof value === 'number')
                _this__u8e3s4.f41(value);
              else {
                if (value instanceof JsonNumber())
                  _this__u8e3s4.g4a(value);
                else {
                  if (typeof value === 'string')
                    _this__u8e3s4.a41(value);
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'Cannot write ' + toString(value) + " of class '" + toString(getKClassFromExpression(value)) + "' to Json";
                    throw IllegalStateException().o(toString(message));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
//region block: exports
export {
  writeAny as writeAny16i13331zbqlc,
};
//endregion

//# sourceMappingURL=JsonWriters.mjs.map
